import React, { useState, useEffect } from "react";
import Navbar from "./items/nav";
import PanelTop from "./items/top-panel";
import RefrashButton from "./items/refrash-button";
import PanelBottom from "./items/bottom-panel";
import BottomSection from "./items/bottom-image";
import Header from "./items/header";

export default function Swap() {
  const [refresh, setRefresh] = useState(false);
  const [tab, setTab] = useState("swap");
  const [swap, setSwap] = useState(false);

  // State for coin list fetched from the API
  const [coinList, setCoinList] = useState([]);

  // State to hold the content of "Sell" and "Buy"
  const [sellContent, setSellContent] = useState({
    coinName: "",
    displayName: "",
    amount: 1, // Initially, sell 1 ETH
    price: 0, // This will be updated once fetched
    iconUrl: "", // URL for the coin icon
  });
  console.log("🚀 ~ Swap ~ sellContent:", sellContent);

  const [buyContent, setBuyContent] = useState({
    coinName: "",
    displayName: "",
    amount: 0, // Calculated based on sell price and buy price
    price: 0, // This will be updated once fetched
    iconUrl: "", // URL for the coin icon
  });

  // Fetch coins data from API on component mount
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoins = async () => {
      setLoading(true); // Start loading

      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd"
        );
        const data = await response.json();

        const formattedData = data.map((coin) => ({
          id: coin.id,
          symbol: coin.symbol.toUpperCase(),
          name: coin.name,
          iconUrl: coin.image,
          price: coin.current_price,
        }));

        setCoinList(formattedData);

        // Find ETH and BTC from the coin list
        const ethCoin = formattedData.find((coin) => coin.symbol === "ETH");
        const btcCoin = formattedData.find((coin) => coin.symbol === "BTC");

        // Check if ETH and BTC are available in the coin list before setting state
        if (ethCoin && btcCoin) {
          // Assuming 1 ETH is sold, calculate how much BTC can be bought
          const amountOfBTC =
            Math.round((ethCoin.price / btcCoin.price) * 1000) / 1000;

          setSellContent({
            coinName: ethCoin.symbol,
            displayName: ethCoin.name,
            amount: 1000, // You are selling 1 ETH by default
            price: ethCoin.price,
            iconUrl: ethCoin.iconUrl,
          });

          setBuyContent({
            coinName: btcCoin.symbol,
            displayName: btcCoin.name,
            amount: amountOfBTC, // Amount of BTC calculated
            price: btcCoin.price,
            iconUrl: btcCoin.iconUrl,
          });
        } else {
          console.error("Error: ETH or BTC not found in the coin list");
        }
      } catch (error) {
        console.error("Error fetching coin data:", error);
      } finally {
        setLoading(false); // Stop loading after data is fetched
      }
    };

    if (loading) {
      fetchCoins();
    }
  }, [loading]); 

  // Handler to swap the content
  const handleSwap = () => {
    setSwap(!swap);

    // Swap the entire content of sellContent and buyContent
    setSellContent((prev) => ({
      ...prev,
      coinName: buyContent.coinName, // Swap coinName
      displayName: buyContent.displayName, // Swap displayName
      price: buyContent.price, // Swap price
      iconUrl: buyContent.iconUrl, // Swap iconUrl
      amount: buyContent.amount, // Swap amount
    }));

    setBuyContent((prev) => ({
      // ...prev,
      coinName: sellContent.coinName, // Swap coinName
      displayName: sellContent.displayName, // Swap displayName
      price: sellContent.price, // Swap price
      iconUrl: sellContent.iconUrl, // Swap iconUrl
      amount: sellContent.amount, // Swap amount
    }));
  };

  // Handler to update `sellContent`
  const updateSellContent = (key, value) => {
    setSellContent((prevSellContent) => ({
      ...prevSellContent, // Spread previous state
      [key]: value, // Update the specific key
    }));
  };

  // Handler to update `buyContent`
  const updateBuyContent = (key, value) => {
    setBuyContent((prevBuyContent) => ({
      ...prevBuyContent, // Spread previous state
      [key]: value, // Update the specific key
    }));
  };
 // Function to calculate and update buy amount
 const calculateBuyAmount = (sellAmount) => {
    const buyAmount = (sellAmount * sellContent.price) / buyContent.price;
    setBuyContent((prev) => ({ ...prev, amount: buyAmount }));
  };

  // Update buyContent.amount whenever sellContent.amount or prices change
  useEffect(() => {
    calculateBuyAmount(sellContent.amount);
  }, [sellContent.amount, sellContent.price, buyContent.price]);

  // Handler for when the sell amount changes
  const handleSellAmountChange = (e) => {
    const newSellAmount = parseFloat(e.target.value);
    setSellContent((prev) => ({ ...prev, amount: newSellAmount }));
  };
  return (
    <>
      <div className="absolute top-0 w-full -z-10">
        <img src="/Header.png" alt="header" className="w-full" />
      </div>

      <Header />
      <Navbar setSwap={setSwap} swap={swap} tab={tab} setTab={setTab} />

      {tab === "limit" ? (
        <div className="flex h-[500px] justify-center items-center">
          <p className="text-3xl text-white">Nothing here..</p>
        </div>
      ) : (
        <>
          <>
            <PanelTop
              content={sellContent}
              updateContent={updateSellContent}
              coinList={coinList}
              handleSellAmountChange={handleSellAmountChange}
            />
            <RefrashButton handleSwap={handleSwap} />
            <PanelBottom
              content={buyContent}
              updateContent={updateBuyContent}
              
              coinList={coinList}
              sellContent={sellContent}
            />
          </>
        </>
      )}

      <BottomSection />
    </>
  );
}
